import React, {createElement, useEffect, useRef, useState} from 'react'
import { Swiper } from 'swiper/esm/react/swiper.js'
import { SwiperSlide } from 'swiper/esm/react/swiper-slide.js'
import SwiperCore, { Navigation, Autoplay } from 'swiper'
import 'swiper/swiper.scss';
import moduleCss from './index.module.scss'
import { Mask } from '@ifeng-fe/lowcode_tool/src/components/Mask'
import { useChip, TYPE_Chip } from '@ifeng-fe/lowcode_tool/src/hooks/useChip'
import { formatChip } from '@ifeng-fe/lowcode_tool/src/method/chip'
import { getThumbnailFromRecommend } from '@ifeng-fe/lowcode_tool/src/method/common'
import Chip from 'Chip'
import md5 from 'md5';
import {FormatImage} from "@ifeng-fe/lowcode_tool/src/components/FormatImage";

SwiperCore.use([ Navigation, Autoplay ])

export interface Swiper_5_Props {
    nodeId?: string
    style?: object,
    swiperChip: TYPE_Chip,
    swiperWidth?: number // 轮播图宽度
    height?: number // 轮播图高度
    formatImageType: 0 | 1 | 2 |3

    // 自动播放
    isAutoPlay: boolean // 是否开启自动播放
    autoSpeed: number // 自动播放的速度

    // nav
    isHasNav: boolean // 是否有nav
    leftNavImage?: string // 左侧nav的图片
    leftNavHoverImage?: string // 左侧nav hover 时的图片
    rightNavImage?: string // 右侧nav的图片
    rightNavHoverImage?: string // 右侧nav hover的图片
    navWidth?: string
    navHeight?: string
    navY?: number
    navX?: number

    // title
    isHasTitle: boolean
    titleLeft?: number;
    titleRight?: number;
    titleY: number;
    titleStyle?: object

    __designMode: string
}

const Swiper_5: React.FC<Swiper_5_Props> = (props) => {
    const {
        nodeId, style, swiperChip, swiperWidth, height, formatImageType,
        isAutoPlay, autoSpeed,
        isHasNav, leftNavImage, leftNavHoverImage, rightNavImage, rightNavHoverImage, navWidth, navHeight, navX, navY,
        isHasTitle, titleStyle, titleLeft, titleRight, titleY,
        __designMode,
    } = props

    const [ isReady, setIsReady ] = useState(false) // 不设置这个，initialSlide 为 0 时左侧有空白，可能是 swiper6 的bug
    const [ isHoverLeft, setIsHoverLeft ] = useState(false)
    const [ isHoverRight, setIsHoverRight ] = useState(false)

    const swiperRef = useRef(null)

    useEffect(() => {
        setTimeout(() => {
            setIsReady(true)
        }, 100)

        window.addEventListener('resize', () => {
            swiperRef.current?.update()
        })

        return () => {
            window.removeEventListener('resize', () => {
                swiperRef.current?.update()
            })
        }
    }, [])

    const [ swiperIndex, setSwiperIndex ] = useState(1)

    const swiperChipData = useChip(swiperChip)
    const swiperChipComponentData = formatChip(swiperChip)

    const getKey = () => {
        return md5(JSON.stringify({ swiperWidth, isAutoPlay, autoSpeed }));
    };

    return (
        <div id={nodeId} style={{ overflow: 'hidden' }}>
            <div style={{ width: `${swiperWidth}px`, margin: '0 auto' }}>
                <Chip {...swiperChipComponentData}>
                    <div style={{ width: `${swiperWidth * 3}px`, overflow: 'hidden', marginLeft: `-${swiperWidth}px` }}>
                        <div className={moduleCss.Swiper_5} style={{ width: `${swiperWidth * 3}px`, ...style }}>
                            <div className={moduleCss.swiperWp}>
                                {
                                    isReady && Array.isArray(swiperChipData) && swiperChipData.length > 0 &&
                                    <Swiper
                                        key={getKey()}
                                        initialSlide={0}
                                        loop={true}
                                        slidesPerView={3}
                                        simulateTouch={__designMode !== 'design'}
                                        navigation={{
                                            prevEl: `.${moduleCss.prev1}, .${moduleCss.prev2}`,
                                            nextEl: `.${moduleCss.next1}, .${moduleCss.next2}`,
                                        }}
                                        onSlideChange={(swiper) => {
                                            setSwiperIndex(swiper.realIndex < swiperChipData.length - 1 ? swiper.realIndex + 1 : 0)
                                        }}
                                        onSwiper={(swiper)  => swiperRef.current = swiper}
                                        autoplay={isAutoPlay ? { delay: autoSpeed, disableOnInteraction: false } : false }
                                        width={swiperWidth * 3}
                                    >
                                        {
                                            swiperChipData.length > 0 && swiperChipData.map((item, index) => {
                                                return (
                                                    <SwiperSlide key={index}>
                                                        <div className={moduleCss.swiperItem} style={{ height: `${height}px`, width: `${swiperWidth}px` }}>
                                                            <a href={item.url} target="_blank">
                                                                <FormatImage src={getThumbnailFromRecommend(item)} formatType={formatImageType} alt={item.title} formatWidth={swiperWidth} formatHeight={height} />
                                                            </a>
                                                        </div>
                                                    </SwiperSlide>
                                                );
                                            })
                                        }
                                    </Swiper>
                                }

                                {
                                    isHasTitle &&
                                    <div className={moduleCss.center} >
                                        <div className={moduleCss.textPart} style={{ bottom: `${titleY}px`, left: titleLeft !== undefined ? `${titleLeft}px` : 'unset', right: titleRight !== undefined ? `${titleRight}px` : 'unset' , ...titleStyle }}>
                                            {swiperChipData[swiperIndex]?.title}
                                        </div>
                                    </div>
                                }
                            </div>

                            <div className={`${moduleCss.left} ${moduleCss.prev1}`} style={{ width: `${swiperWidth}px` }} />
                            <div className={`${moduleCss.right} ${moduleCss.next1}`} style={{ width: `${swiperWidth}px` }} />
                            {
                                isHasNav &&
                                <>
                                    <div className={`${moduleCss.leftBtn} ${moduleCss.prev2}`} style={{ top: `${navY}px`, left: `${navX}px` }}>
                                        <img style={{ width: `${navWidth}px`, height: `${navHeight}px` }} src={isHoverLeft ? leftNavHoverImage || leftNavImage : leftNavImage} alt="" onMouseEnter={() => setIsHoverLeft(true)} onMouseLeave={() => setIsHoverLeft(false)} />
                                    </div>
                                    <div className={`${moduleCss.rightBtn} ${moduleCss.next2}`} style={{ top: `${navY}px`, right: `${navX}px` }}>
                                        <img style={{ width: `${navWidth}px`, height: `${navHeight}px` }} src={isHoverRight ? rightNavHoverImage || rightNavImage : rightNavImage} alt="" onMouseEnter={() => setIsHoverRight(true)} onMouseLeave={() => setIsHoverRight(false)} />
                                    </div>
                                </>
                            }
                            <Mask visible={!swiperChip.id} zIndex={3}>
                                示例推荐位碎片—{swiperChip.default?.id}
                            </Mask>
                        </div>
                    </div>
                </Chip>
            </div>
        </div>
    )
}

export default Swiper_5
